import { Heart } from '@phosphor-icons/react/dist/ssr';

import classNames from 'classnames';
import { useState } from 'react';
import type { CommentData } from '../../types';
import { useComponentContext } from '../context/useComponentContext';

import { actionText } from '../PostCommentsFeed.css';

interface Props {
  comment: CommentData;
}

const CommentLikeAction = ({ comment }: Props) => {
  const { onLike, translations, isVisitorLoggedIn, onClickLogin } = useComponentContext();
  const [likedIds] = useState<CommentData['likes']>(comment.likes || []);
  const [liked, setLiked] = useState(comment.is_liked || false);
  const [commentLikeCount, setCommentLikeCount] = useState(likedIds?.length || 0);

  const handleConditionalRendering = () => {
    setLiked(!liked);

    if (liked) {
      setCommentLikeCount(commentLikeCount - 1);
    } else {
      setCommentLikeCount(commentLikeCount + 1);
    }
  };

  const handleClick = async (_e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isVisitorLoggedIn) {
      onClickLogin?.();
      return;
    }
    const formData = new FormData();
    formData.append('comment_id', comment.id);

    handleConditionalRendering();

    const response = await onLike?.(formData);
    if (!response) {
      handleConditionalRendering();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={classNames(actionText, 'flex flex-row gap-x-1 leading-4 items-center uppercase')}
    >
      <Heart className="h-4 w-4 text-current" weight={liked ? 'fill' : undefined} />
      <span>
        {translations?.['comments.like']}
        {commentLikeCount > 0 && `(${commentLikeCount})`}
      </span>
    </button>
  );
};

export default CommentLikeAction;
